import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import { DefaultValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useEditorialTeamCreate } from '@/module/Author/EditorialTeam/model/EditorialTeamQuery';
import {
  EditorialTeamSchema,
  defaultEditorialTeamValues,
  editorialTeamSchema,
} from '@/module/Author/EditorialTeam/model/EditorialTeamSchema';

import { useAppNotification } from '@feature/utils';

import { EditorialTeamForm } from './EditorialTeamForm';

export function EditorialTeamCreate() {
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useEditorialTeamCreate();

  const defaultValues: DefaultValues<EditorialTeamSchema> = useMemo(
    () => ({
      ...defaultEditorialTeamValues,
    }),
    [],
  );

  const notification = useAppNotification();
  const navigate = useNavigate();

  const onSubmit = (values: EditorialTeamSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: newEditorialTeam => {
        notification.success();
        navigate({
          to: '/author/editorial-team/$editorialTeamId',
          params: { editorialTeamId: String(newEditorialTeam.id) },
        });
      },
    });
  };

  return (
    <EditorialTeamForm
      title={t('editorialTeams.form.title.create')}
      schema={editorialTeamSchema}
      defaultValues={defaultValues}
      values={undefined}
      isSubmitting={isPending}
      isError={isError}
      isSuccess={isSuccess}
      onSubmit={onSubmit}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
